
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { IconWordmarkComponent } from '../icon-wordmark/icon-wordmark.component';

@Component({
    selector: 'app-be-logo-v2',
    templateUrl: './be-logo-v2.component.html',
    styleUrls: ['./be-logo-v2.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [IconWordmarkComponent]
})
export class BeLogoV2Component {
  @Input() isLink = true;
  @Input() url?: string = 'https://www.bestegg.com/';
}
